/* Mock data for Session 5 — replaced by real API in Session 6 */

export type CallStatus = 'quote' | 'book' | 'new' | 'missed';

export interface MockCall {
  id:     number;
  who:    string;
  init:   string;
  snip:   string;
  time:   string;
  date:   string;
  status: CallStatus;
  dur:    string;
}

export const MOCK_CALLS: MockCall[] = [
  { id: 1,  who: 'Družina Horvat',      init: 'DH', snip: 'Počena cev pod umivalnikom, nujno…',     date: '13. 6.', time: '09:42', status: 'quote',  dur: '1:38' },
  { id: 2,  who: 'Pekarna Kruhek',      init: 'PK', snip: 'Servis pečice, ne greje enakomerno',     date: '13. 6.', time: '11:08', status: 'book',   dur: '2:04' },
  { id: 3,  who: 'Neznana številka',    init: '?',  snip: 'Povpraševanje za adaptacijo kopalnice',  date: '13. 6.', time: '13:21', status: 'new',    dur: '0:54' },
  { id: 4,  who: 'Anže Petrič',         init: 'AP', snip: 'Zamašen odtok v kuhinji',               date: '13. 6.', time: '14:50', status: 'quote',  dur: '1:12' },
  { id: 5,  who: 'Vrtec Sonček',        init: 'VS', snip: 'Redni servis sanitarij, ponovitev',      date: '13. 6.', time: '15:33', status: 'book',   dur: '1:47' },
  { id: 6,  who: 'Maja Kos',            init: 'MK', snip: 'Pušča radiator v dnevni sobi',           date: '13. 6.', time: '16:10', status: 'new',    dur: '0:48' },
  { id: 7,  who: 'Gostilna Pri Lipi',   init: 'GL', snip: 'Menjava bojlerja, nujno do petka',       date: '13. 6.', time: '17:02', status: 'quote',  dur: '2:31' },
  { id: 8,  who: 'Rok Jamšek',          init: 'RJ', snip: 'Zamenjava vtičnic v dnevni sobi',        date: '12. 6.', time: '08:15', status: 'new',    dur: '0:41' },
  { id: 9,  who: 'Mercator Kranj',      init: 'MC', snip: 'Letni servis hladilnih naprav',          date: '12. 6.', time: '10:30', status: 'book',   dur: '2:58' },
  { id: 10, who: 'Frančiška Kržičnik', init: 'FK', snip: 'Mašenje odtoka, kuhinja, ne odgovori',   date: '11. 6.', time: '15:22', status: 'missed', dur: '0:00' },
  { id: 11, who: 'Kovač Gradnje',       init: 'KG', snip: 'Elektroinštalacije za poslovni prostor', date: '11. 6.', time: '09:05', status: 'book',   dur: '3:17' },
  { id: 12, who: 'Kmetija Počivalniku', init: 'KP', snip: 'Plinska peč ne vžge, nujno',             date: '10. 6.', time: '18:44', status: 'quote',  dur: '1:55' },
];

export interface MockScheduleItem {
  time:  string;
  title: string;
  loc:   string;
}

export const MOCK_SCHEDULE: MockScheduleItem[] = [
  { time: '08:00', title: 'Družina Horvat — počena cev',  loc: 'Trubarjeva 14, Kranj' },
  { time: '11:30', title: 'Pekarna Kruhek — servis',      loc: 'Glavni trg 2, Kranj'  },
  { time: '15:00', title: 'Ogled — adaptacija kopalnice', loc: 'Cesta na Brdo 8'       },
];

export const STATUS_CONFIG: Record<CallStatus, { cls: string; label: string }> = {
  quote:  { cls: 'pill--success', label: 'ponudba' },
  book:   { cls: 'pill--info',    label: 'termin'  },
  new:    { cls: 'pill--copper',  label: 'novo'    },
  missed: { cls: 'pill--muted',   label: 'zgrešen' },
};

/* ---- Call detail (transcript + summary + extracted info) ---- */

export type TranscriptSpeaker = 'agent' | 'caller';

export interface TranscriptLine {
  who:  TranscriptSpeaker;
  t:    string;
  text: string;
}

export interface ExtractedInfo {
  person?:      string;
  address?:     string;
  appointment?: string;
  phone?:       string;
}

export interface CallDetail {
  transcript: TranscriptLine[];
  summary:    string;
  extracted:  ExtractedInfo;
}

export const MOCK_CALL_DETAILS: Partial<Record<number, CallDetail>> = {
  1: {
    transcript: [
      { who: 'caller', t: '00:02', text: 'Dober dan, kličem ker imam počeno cev pod umivalnikom v kopalnici.' },
      { who: 'agent',  t: '00:08', text: 'Razumem, to je nujno. Vam voda še vedno teče?' },
      { who: 'caller', t: '00:14', text: 'Sem zaprl glavni ventil, ampak je vse mokro.' },
      { who: 'agent',  t: '00:19', text: 'Prav ste ravnali. Marko lahko pride jutri med 8. in 10. uro — vam ustreza?' },
      { who: 'caller', t: '00:27', text: 'Ja, super. Naslov je Trubarjeva 14, Kranj.' },
      { who: 'agent',  t: '00:33', text: 'Zabeleženo. Marko vas pokliče pred prihodom. Lep dan!' },
    ],
    summary:   'Stranka ima počeno cev pod umivalnikom in je zaprla glavni ventil. Dogovorjen ogledni obisk jutri med 8:00 in 10:00 — poslati ponudbo za zamenjavo cevi.',
    extracted: { person: 'Janez Horvat', address: 'Trubarjeva 14, Kranj', appointment: 'Jut. 08:00–10:00', phone: '+386 41 123 456' },
  },
  2: {
    transcript: [
      { who: 'caller', t: '00:01', text: 'Živjo, pekarna Kruhek, imamo problem s pečico — ne segreje se enakomerno.' },
      { who: 'agent',  t: '00:07', text: 'Razumem. Je to konvekcijska pečica ali klasična?' },
      { who: 'caller', t: '00:12', text: 'Konvekcijska, kupili smo jo pred tremi leti.' },
      { who: 'agent',  t: '00:17', text: 'Marko ima termin v sredo ob 11:30 — bi vam ustrezalo?' },
      { who: 'caller', t: '00:23', text: 'Odlično, naslov je Glavni trg 2, Kranj.' },
      { who: 'agent',  t: '00:28', text: 'Super, termin je rezerviran. Marko bo poslal SMS potrdilo.' },
    ],
    summary:   'Pekarna Kruhek ima težave s konvekcijsko pečico (3 leta stara). Dogovorjen servisni termin v sredo ob 11:30 na Glavni trg 2, Kranj.',
    extracted: { person: 'Pekarna Kruhek', address: 'Glavni trg 2, Kranj', appointment: 'Sreda, 11:30', phone: '+386 4 201 5500' },
  },
  3: {
    transcript: [
      { who: 'caller', t: '00:03', text: 'Pozdravljeni, zanima me adaptacija kopalnice — koliko bi to stalo?' },
      { who: 'agent',  t: '00:09', text: 'Veseli me vaše povpraševanje. Bi mi lahko povedali kvadraturo kopalnice?' },
      { who: 'caller', t: '00:16', text: 'Nekje 6 kvadratnih metrov, zamenjava vseh sanitarij.' },
      { who: 'agent',  t: '00:22', text: 'Razumem. Marko vas bo poklical za ogled in brezplačno oceno. Vaša številka?' },
      { who: 'caller', t: '00:30', text: 'Ja, ta številka je ok. Hvala.' },
      { who: 'agent',  t: '00:34', text: 'Super, Marko vas pokliče v dveh dneh. Lep dan!' },
    ],
    summary:   'Neznana stranka sprašuje za adaptacijo kopalnice (cca. 6 m²) — zamenjava vseh sanitarij. Zahteva povratni klic za ogled in oceno stroškov.',
    extracted: { appointment: 'Povratni klic v 2 dneh' },
  },
  4: {
    transcript: [
      { who: 'caller', t: '00:02', text: 'Dober dan, imam zamašen odtok v kuhinji, voda sploh ne odteka.' },
      { who: 'agent',  t: '00:07', text: 'Razumem. Ali ste že poskusili z odmaševalcem?' },
      { who: 'caller', t: '00:13', text: 'Ja, nič ne pomaga. Verjetno je bolj globoko.' },
      { who: 'agent',  t: '00:18', text: 'Marko bi lahko prišel danes ob 15:00 ali jutri — kdaj vam ustreza?' },
      { who: 'caller', t: '00:25', text: 'Danes je ok. Sem na Cesti Andreja Bitenca 9.' },
      { who: 'agent',  t: '00:30', text: 'Odlično, Marko bo ob 15:00. Zbogom!' },
    ],
    summary:   'Stranki je zamašen odtok v kuhinji, odmaševalec ni pomagal — verjetno je zamašitev globlja. Dogovorjen obisk danes ob 15:00.',
    extracted: { person: 'Anže Petrič', address: 'C. Andreja Bitenca 9', appointment: 'Danes, 15:00' },
  },
  5: {
    transcript: [
      { who: 'caller', t: '00:01', text: 'Živjo, vrtec Sonček, kličemo za letni servis sanitarij kot vsako leto.' },
      { who: 'agent',  t: '00:06', text: 'Lepo slišati, da ste zvesti stranki. Kateri termin bi bil primeren?' },
      { who: 'caller', t: '00:12', text: 'Naslednji teden v torek, po 13:00.' },
      { who: 'agent',  t: '00:17', text: 'Rezerviram torek ob 13:30. Naslov ostaja Kidričeva 12, Kranj?' },
      { who: 'caller', t: '00:23', text: 'Ja, točno tako. Hvala lepa!' },
    ],
    summary:   'Redna letna naročnina vrtca Sonček za servis sanitarij. Termin v torek naslednji teden ob 13:30 na Kidričevi 12, Kranj.',
    extracted: { person: 'Vrtec Sonček', address: 'Kidričeva 12, Kranj', appointment: 'Torek 13:30 (nasl. teden)' },
  },
  6: {
    transcript: [
      { who: 'caller', t: '00:02', text: 'Dober dan, imam radiator ki pušča v dnevni sobi.' },
      { who: 'agent',  t: '00:07', text: 'Koliko vode izgublja — kaplja ali teče?' },
      { who: 'caller', t: '00:13', text: 'Počasi kaplja pri spodnjem priključku.' },
      { who: 'agent',  t: '00:18', text: 'Verjetno tesnilo. Marko ima prosto v četrtek popoldne. Gre?' },
      { who: 'caller', t: '00:24', text: 'Četrtek ob 16:00 bi šlo. Ulica Mirka Vadnova 4, Kranj.' },
    ],
    summary:   'Pušča radiator pri spodnjem priključku (kaplja) — verjetno zamenjava tesnila. Termin četrtek ob 16:00 na Ulici Mirka Vadnova 4.',
    extracted: { person: 'Maja Kos', address: 'Ul. Mirka Vadnova 4', appointment: 'Četrtek, 16:00' },
  },
  7: {
    transcript: [
      { who: 'caller', t: '00:01', text: 'Gostilna Pri Lipi, nujno rabimo menjavo bojlerja — do petka moramo imeti toplo vodo.' },
      { who: 'agent',  t: '00:08', text: 'Razumem nujnost. Kakšna je kapaciteta obstoječega bojlerja?' },
      { who: 'caller', t: '00:14', text: '200 litrov, električni.' },
      { who: 'agent',  t: '00:19', text: 'Marko ima jutri zjutraj prosto. Ali je dostop do kotlovnice možen po 7:00?' },
      { who: 'caller', t: '00:26', text: 'Ja, od 7:00 dalje. Smo na Titovi 3, Kranj.' },
      { who: 'agent',  t: '00:32', text: 'Marko bo jutri ob 7:30. Pošljemo vam pisno ponudbo pred prihodom.' },
    ],
    summary:   'Gostilna Pri Lipi potrebuje nujno menjavo 200 L električnega bojlerja do petka. Obisk jutri ob 7:30 na Titovi 3 — poslati pisno ponudbo.',
    extracted: { person: 'Gostilna Pri Lipi', address: 'Titova 3, Kranj', appointment: 'Jut. 07:30' },
  },
  8: {
    transcript: [
      { who: 'caller', t: '00:02', text: 'Živjo, imam problem z vtičnicami v dnevni sobi — ne delajo.' },
      { who: 'agent',  t: '00:07', text: 'Ste preverili zaščitne stikale v razdelilni plošči?' },
      { who: 'caller', t: '00:13', text: 'Ja, so ok. Verjetno je napaka v napeljavi.' },
      { who: 'agent',  t: '00:18', text: 'Razumem. Marko vas pokliče jutri za termin.' },
    ],
    summary:   'Stranka ima nedelujoče vtičnice v dnevni sobi, zaščitna stikala so ok — verjetna napaka v napeljavi. Povratni klic jutri za termin.',
    extracted: { person: 'Rok Jamšek', appointment: 'Povratni klic jutri' },
  },
  9: {
    transcript: [
      { who: 'caller', t: '00:01', text: 'Mercator Kranj, kličemo za letni servis hladilnih naprav.' },
      { who: 'agent',  t: '00:06', text: 'Koliko enot imate za servis?' },
      { who: 'caller', t: '00:10', text: 'Osem hladilnih omar v prodajni dvorani.' },
      { who: 'agent',  t: '00:15', text: 'Za večje naročilo vam bo Marko poslal pisno ponudbo in predlagal termin.' },
      { who: 'caller', t: '00:21', text: 'Odlično, pošljite na nabava@mercator-kj.si. Hvala.' },
    ],
    summary:   'Mercator Kranj naroča letni servis 8 hladilnih omar. Ponudbo poslati na nabava@mercator-kj.si in dogovoriti termin za večje naročilo.',
    extracted: { person: 'Mercator Kranj', appointment: 'Ponudba po e-pošti' },
  },
  10: {
    transcript: [],
    summary:   'Klic ni bil sprejet — stranka ni pustila sporočila.',
    extracted: { person: 'Frančiška Kržičnik' },
  },
  11: {
    transcript: [
      { who: 'caller', t: '00:02', text: 'Kovač Gradnje, zanima nas elektroinštalacija za nov poslovni prostor 80 m².' },
      { who: 'agent',  t: '00:09', text: 'Za večji projekt bomo organizirali ogled. Kdaj ste na lokaciji dosegljivi?' },
      { who: 'caller', t: '00:16', text: 'Vsak delavnik od 7:00 do 15:00. Lokacija je Ob Savi 24, Medvode.' },
      { who: 'agent',  t: '00:24', text: 'Marko vas bo kontaktiral za ogled in ponudbo v tem tednu.' },
    ],
    summary:   'Kovač Gradnje povprašuje za elektroinštalacije novega poslovnega prostora (80 m²). Ogled in ponudba ta teden — lokacija Ob Savi 24, Medvode.',
    extracted: { person: 'Kovač Gradnje', address: 'Ob Savi 24, Medvode', appointment: 'Ogled ta teden' },
  },
  12: {
    transcript: [
      { who: 'caller', t: '00:01', text: 'Kmetija Počivalniku, plinska peč se ne vžge, nujno!' },
      { who: 'agent',  t: '00:06', text: 'Je morda ugasnila varnostna zaklopka ali je viden vonj po plinu?' },
      { who: 'caller', t: '00:13', text: 'Vonja ni, zaklopka je ok. Verjetno vžigalo.' },
      { who: 'agent',  t: '00:18', text: 'Razumem. Marko bo pri vas danes ob 20:00 — je možen dostop?' },
      { who: 'caller', t: '00:24', text: 'Ja, smo na Prečni 5, Šenčur. Hvala!' },
    ],
    summary:   'Plinska peč na kmetiji se ne vžge — vonja ni, verjetno okvara vžigala. Nujen obisk danes ob 20:00 na Prečni 5, Šenčur.',
    extracted: { person: 'Kmetija Počivalniku', address: 'Prečna 5, Šenčur', appointment: 'Danes, 20:00' },
  },
};
